
import React, { useState } from 'react';
import HvacFloorMap from './HvacFloorMap';
import HvacControlPanel from './HvacControlPanel';
import HvacEnergyStats from './HvacEnergyStats';
import HvacWeatherData from './HvacWeatherData';

const HvacManagementGrid: React.FC = () => {
  const [selectedFloor, setSelectedFloor] = useState<number>(1);
  const [selectedZone, setSelectedZone] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 p-2">
      {/* Floor Map - Takes up more space */}
      <div className="lg:col-span-2 bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700">
        <HvacFloorMap 
          selectedFloor={selectedFloor} 
          onFloorChange={setSelectedFloor}
          selectedZone={selectedZone}
          onZoneSelect={setSelectedZone}
        />
      </div>

      {/* Control Panel */}
      <div className="flex flex-col gap-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700">
          <HvacControlPanel 
            selectedFloor={selectedFloor}
            selectedZone={selectedZone}
          />
        </div>

        {/* Weather Data */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700">
          <HvacWeatherData />
        </div>

        {/* Energy Consumption Stats */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700">
          <HvacEnergyStats 
            selectedFloor={selectedFloor}
            selectedZone={selectedZone}
          />
        </div>
      </div>
    </div>
  );
};

export default HvacManagementGrid;
